{
  "addressLoadFailed": "ไม่สามารถโหลดที่อยู่ได้",
  "usdtTrc20": "USDT (TRC20)",
  "usdtTrc20Network": "USDT TRC-20",
  "rateLoadFailed": "ไม่สามารถโหลดอัตราแลกเปลี่ยนได้",
  "copied": "คัดลอกแล้ว",
  "conversionDescription": "หลังโอน USDT เข้ามา ระบบจะแลกเป็น {{token}} ตามอัตรา USDT ของแพลตฟอร์มและเก็บไว้ในกระเป๋าเงิน {{token}} ของคุณ",
  "rate": "อัตราแลกเปลี่ยน",
  "rateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "title": "แลกเปลี่ยน",
  "hintTitle": "คำแนะนำ",
  "addressOnlySupports": "ที่อยู่และคิวอาร์โค้ดนี้รองรับเฉพาะ",
  "addressOnlySupportsSuffix": "เท่านั้น การโอนผิดประเภทอาจกู้คืนไม่ได้และแพลตฟอร์มจะไม่ชดเชย โปรดยืนยันประเภทที่ต้องการโอน",
  "confirmationHint": "การถอนทั่วไปต้องผ่านการยืนยันจากหลายบล็อก โปรดถือว่าการโอนสำเร็จเมื่อได้รับยอดเข้าบัญชี"
}
